<template>
  <section class="card card-modern card-big-info">
    <div class="card-body">
      <div class="row">
        <div class="col-lg-2-5 col-xl-1-5">
          <i class="card-big-info-icon bx bx-detail"></i>
          <h2 class="card-big-info-title">Povezani artikli</h2>
          <p class="card-big-info-desc">Dodajte željene artikle</p>
        </div>

        <div class="col-lg-3-5 col-xl-4-5">
          <div class="form-group row align-items-center">
            <div class="col">
              <div class="form-group row pb-3">
                <label
                  class="col-lg-5 col-xl-3 control-label text-lg-end mb-0 mt-2"
                >
                  Pretraga artikala
                </label>
                <div class="col-lg-7 col-xl-6 position-relative">
                  <input
                    type="text"
                    class="search-term form-control"
                    placeholder="Pretraga"
                    v-model="searchField"
                    @input="onSearchHandle"
                    @blur="onBlurHandle"
                    @focus="onFocusHandle"
                  />

                  <ul class="article-list bg-body" v-if="showSearchResults">
                    <li
                      v-for="article in articles"
                      :key="article.id"
                      @click="addLinkedArticle(article)"
                    >
                      <div class="article-wrapper">
                        <img
                          v-if="article.highlightedImageUrl"
                          :src="`${baseUrl}${article.highlightedImageUrl}`"
                          class="article-image"
                        />

                        <img
                          v-else
                          class="article-image"
                          :src="'img/products/product-8.jpg'"
                        />
                        <div class="article-description">
                          <div class="article-title">
                            {{ article.title }}
                          </div>
                          <div class="article-code">
                            {{ article.code }}
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>

                <div
                  v-if="
                    value && value.length > 0
                  "
                >
                  <div class="form-group row align-items-center mt-4">
                    <div class="col">
                      <div class="popup-gallery row">
                        <div
                          v-for="(item, index) in value"
                          :key="item.id"
                          class="img-fluid col-xs-4 col-auto mb-4 me-1 img-wrapper"
                        >
                          <div
                            class="delete-image"
                            @click="removeLinkedArticle(index)"
                          >
                            <i class="bx bx-x"></i>
                          </div>
                          <img
                            v-if="item.highlightedImageUrl"
                            :src="`${baseUrl}${item.highlightedImageUrl}`"
                            class="img-thumbnail img-thumbnail-custom highlighted"
                          />

                          <img
                            v-else
                            class="img-thumbnail img-thumbnail-custom highlighted"
                            :src="'img/products/product-8.jpg'"
                          />

                          <div class="article-title-list">
                            {{ item.title }}
                          </div>

                          <div class="article-code-list">
                            {{ item.code }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { debounce } from 'lodash';

import config from '@/config';

export default {
  name: 'LinkedArticles',
  props: ['value'],
  data() {
    return {
      searchField: '',
      showSearchResults: false,
      baseUrl: config.baseUrl,
    };
  },
  computed: {
    articles() {
      return this.$store.getters.getArticles;
    },
    article() {
      return this.$store.getters.getArticle;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.value = value;
        this.$emit('input', value);
      },
    },
  },
  methods: {
    addLinkedArticle(article) {
      if (this.value.length === 0) {
        this.value.push(article);
      } else {
        const item = this.value.find((item) => item.id === article.id);
        if (!item) {
          this.value.push(article);
        } else {
          this.$toast.error('Artikal je već dodan u povezane');
        }
      }
      this.showSearchResults = false;
      this.searchField = '';
    },
    removeLinkedArticle(index) {
      this.value.splice(index, 1);
    },
    onBlurHandle() {
      const timerId = setTimeout(() => {
        this.showSearchResults = false;
        clearTimeout(timerId);
      }, 150);
    },
    onFocusHandle() {
      if (this.searchField) {
        this.showSearchResults = true;
      }
    },
    onSearchHandle: debounce(function () {
      const ignoreArticleIds = this.value.map((item) => item.id);

      if(this.$route.name === 'EditArticle') {
        ignoreArticleIds.push(this.article.id);
      }
      this.showSearchResults = true;
      this.$store.dispatch('getArticles', {
        sortBy: 'title',
        isSortAscending: true,
        page: 1,
        retrieveAll: true,
        quickSearch: this.searchField.trim(),
        ignoreArticleIds,
      });
    }, 300),
  },
};
</script>

<style lang="scss" scoped>
@import './assets/scss/linked-articles.scss';
</style>